<template>
  <div id="why-us">
    <!-- <header class="section-header">
      <h2>Por que nós?</h2>
      <h5>Porque aqui o balé é muito mais divertido.</h5>
    </header> -->

    <b-row align-h="center">
      <b-col col md="6" cols="10">
        <div id="why_img" class="why-us-img">
          <img src="../img/porquenos.jpeg" alt class="img-fluid">
        </div>
      </b-col>
      <b-col col md="6" cols="10">
        <div class="why-us-content">          
          <div id="why_msg1" class="features wow bounceInUp clearfix">
            <i class="icon ion-md-bookmark" style="color: #f058dc;"></i>
            <h4>Muito mais que movimento.</h4>

            <p>
              Nós acreditamos que a dança possui milhares de objetivos e importância, principalmente para o desenvolvimento infantil, tanto na cognição e psicomotricidade quanto na área psicossocial e psicológica.   
              Por isso, ao ser uma Mariazinha, a criança está inserida em um meio que amplia os seus olhares para a dança, e ela se torna mediadora de muitos processos, possibilitando à bailarina um maior conhecimento de seu corpo, do espaço que habita, superando as suas limitações e reconhecendo suas habilidades e potencialidades.
            </p>
          </div>

          <div id="why_msg2" class="features wow bounceInUp clearfix">
            <i class="icon ion-md-bookmark" style="color: #ffb774;"></i>
            <h4>Conforto e Segurança</h4>
            <p>
              É no ambiente escolar que a criança tem suas primeiras amizades, onde ela interage socialmente e aprende a respeitar a individualidade de cada um. É também neste ambiente que a criança se sente segura e acolhida, é lá onde ela passa grande parte da sua infância e cria suas primeiras memórias. Sendo assim, as ‘Aulas Maria Bailarina’ dentro das escolas facilita os primeiros contatos entre professora e bailarina e nos proporciona momentos de diversão e muito aprendizado. Segurança e conforto ao estar em um ambiente já conhecido, rotineiro e ainda compartilhando experiências junto de suas amigas.
Desta forma, há 8 anos nosso Projeto tem funcionado pensando no melhor para as Mariazinhas e suas famílias!
            </p>
          </div>

          <div id="why_msg3" class="features wow bounceInUp clearfix">
            <i class="icon ion-md-bookmark" style="color: #589af1;"></i>
            <h4>Qualidade</h4>
            <p>
              <!-- Prezamos pela qualidade do nosso trabalho ao conduzir as Mariazinhas nos seus primeiros passos dançantes. Um dos nossos maiores objetivos é que a criança tenha uma experiência dançante leve, respeitada e feliz. Para cumprir com isso, contamos com professoras capacitadas que buscam se aperfeiçoar constantemente e, principalmente, ter um olhar generoso para cada bailarina. Temos muito orgulho em estarmos alcançando essa meta, em afetar positivamente o desenvolvimento das pequenas e sermos diariamente afetadas por elas, em nossas trocas dançantes. -->
              Em 2014 fizemos nosso primeiro espetáculo, ‘Entre Flores e Sapatilhas: Nossos Sonhos’. Desde então criamos e contamos novas histórias, todas elas despertaram em nós uma infinidade de sentimentos bons, no ano passado com o espetáculo ‘Síntese de nós‘, relembramos a nossa história com lindas recordações de noites muito especiais.
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "porquenos",
  data() {
    return {
    }
  },
  methods: {
    animationElement(posEl, isMostrar) {
      let elImg = document.querySelector('#why_img')
      let elmsg1 = document.querySelector('#why_msg1')
      let elmsg2 = document.querySelector('#why_msg2')
      let elmsg3 = document.querySelector('#why_msg3')
      if (isMostrar) {
        elImg.classList.add('animate__animated', 'animate__fadeInDownBig')
        elImg.style.setProperty('--animate-duration', '1s')
        elmsg1.classList.add('animate__animated', 'animate__zoomInDown')
        elmsg1.style.setProperty('--animate-duration', '0.6s')
        elmsg1.style.setProperty('--animate-delay', '1.3s')
        elmsg2.classList.add('animate__animated', 'animate__zoomInDown')
        elmsg2.style.setProperty('--animate-duration', '1s')
        elmsg2.style.setProperty('--animate-delay', '1.5s')
        elmsg3.classList.add('animate__animated', 'animate__zoomInDown')
        elmsg3.style.setProperty('--animate-duration', '1.4s')
      } else {
        elImg.classList.remove('animate__animated', 'animate__fadeInDownBig')
        elmsg1.classList.remove('animate__animated', 'animate__zoomInDown')
        elmsg2.classList.remove('animate__animated', 'animate__zoomInDown')
        elmsg3.classList.remove('animate__animated', 'animate__zoomInDown')
      }
    }
  }
};
</script>

<style scoped>
#why-us {
  padding: 40px 0;
}

#why-us .section-header {
  padding-bottom: 50px;
}


#why-us .why-us-content .features {
  margin: 0 0 15px 0;
  padding: 0;
  transition: 0.3s ease-in-out;
}

#why-us .why-us-content .features i {
  font-size: 36px;
  float: left;
}

#why-us .why-us-content .features h4 {
  font-size: 24px;
  font-weight: 600;
  margin-left: 56px;
  color: #413e66;
  margin-bottom: 5px;
}

#why-us .why-us-content .features p {
  font-size: 16px;
  margin-left: 56px;
  color: #555186;
}

#why-us .counters {
  padding-top: 40px;
}

#why-us .counters span {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 48px;
  display: block;
  color: #555186;
}

#why-us .counters p {
  padding: 0;
  margin: 0 0 20px 0;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  color: #8a87b6;
}


:root {
  --animate-delay: 0.9s;
}


</style>



// WEBPACK FOOTER //
// src/views/porquenos.vue